import styled from 'styled-components';
import { DeprecatedGrid as Grid } from '@simplywallst/ui-core';

export const Wrapper = styled(Grid)`
  padding: ${({ theme }) => theme.x4spacePx}px;
`;
